import React from 'react';
import { array, bool, func, number, object, string } from 'prop-types';

import { Checkbox } from '../../../../ps-aspect-design';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { longDateString } from '../../../lib/formatters';
import Favorite from '../ReportFavorite/ReportFavoriteContainer';
import Tag from '../../../Tag/Tag';
import { Popover, Stack } from '@mantine/core';

import './ReportCard.scss';

ReportCard.propTypes = {
  category: string,
  categoryId: number,
  description: string,
  embed: string,
  history: object,
  id: string,
  isFavorite: bool,
  isVisualization: bool,
  launchDarklyFeatureFlags: object,
  location: object,
  modified: number,
  modifiedBy: string,
  onSelectPopular: func,
  reportClick: func,
  reportSelectClick: func,
  scopeCode: string,
  scopeName: string,
  selectable: bool,
  selected: bool,
  selectedPopularReports: array,
  style: object,
  thumbnail: string,
  title: string,
  url: string,
  userCanSelect: bool,
  userReportViewer: bool
};

export default function ReportCard(props) {
  function renderVisualization() {
    if (!props.thumbnail)
      return (
        <Link className="report__visualization" to="#" onClick={props.reportClick}>
          <div className="report__visualization-overlay" />
        </Link>
      );
    return (
      <Link className="report__visualization" to="#" onClick={props.reportClick}>
        <div className="report__visualization-overlay">
          <img src={props.thumbnail} title="viz" />
        </div>
      </Link>
    );
  }

  const categoryClassName = props.category.toLowerCase().replace(/ /g, '');
  const { modified, modifiedBy, scopeName, userReportViewer, popularFilter } = props;
  const app = window.location.pathname.includes('/mp/') ? 'MarketPay' : 'Insight Lab';
  const isStandardScope = scopeName === 'Standard';
  const lastModifiedBy =
    isStandardScope && app === 'MarketPay' ? app : isStandardScope && app === 'Insight Lab' ? app : modifiedBy;

  const selectClass = classNames('report__checkbox', {
    selectable: props.userCanSelect,
    selected: props.selected
  });

  const reportClass = classNames({
    report: true,
    'report-selectable': props.userCanSelect,
    'report-selected': props.selected
  });

  if (props.launchDarklyFeatureFlags && props.launchDarklyFeatureFlags['rw-react']) return (
    <Popover width={300} position="bottom" offset={-50} withArrow shadow="md">
      <Popover.Target>
        <article className={reportClass} key={props.id} style={props.style} onClick={props.isVisualization ? props.reportClick : () => console.log('FOO')}>
          <div className="report__tags">
            <Tag text={props.scopeName} />
          </div>

          {!userReportViewer && props.userCanSelect && (
            <div
              onClick={e => {
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
              }}
            >
              <Checkbox
                checked={props.selected}
                className={selectClass}
                onChange={(_, value) => {
                  if (popularFilter) {
                    props.onSelectPopular(value);
                  } else {
                    props.reportSelectClick();
                  }
                }}
              />
            </div>
          )}

          {props.isVisualization ? renderVisualization() : <div className="report__icon icon-doc-text" />}

          <div className="report__details">
            <h2 className={`report__category ${categoryClassName}`}>{props.category}</h2>
            <h1 className="report__title">{props.title}</h1>
            <p className="report__description">{props.description}</p>
          </div>
          <div className="report__metadata">
            <div className="report__modified">
              <div className="report__modified-label">
                <i className="icon-clock" /> Last modified
              </div>
              <div className="report__modified-date">
                {longDateString(new Date(modified))} - {lastModifiedBy}
              </div>
            </div>
          </div>
          <div className="report__actions">
            <a className="report__link" onClick={props.reportClick}>
              Preview Report
            </a>
          </div>
          <Favorite isFavorite={props.isFavorite} id={props.id} />
        </article>
      </Popover.Target>
      <Popover.Dropdown>
        <Stack>
          <Link className="report__link" to={{ pathname: `/reports/${props.id}`, state: { history: location.pathname } }}>
            Report Writer New
          </Link>
          <Link className="report__link" to={{ pathname: props.url, state: { history: location.pathname } }}>
            Report Writer Classic
          </Link>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  )

  return (
    <article className={reportClass} key={props.id} style={props.style} onClick={props.reportClick}>
      <div className="report__tags">
        <Tag text={props.scopeName} />
      </div>

      {!userReportViewer && props.userCanSelect && (
        <div
          onClick={e => {
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
          }}
        >
          <Checkbox
            checked={props.selected}
            className={selectClass}
            onChange={(error, value) => {
              if (popularFilter) {
                props.onSelectPopular(value);
              } else {
                props.reportSelectClick();
              }
            }}
          />
        </div>
      )}

      {props.isVisualization ? renderVisualization() : <div className="report__icon icon-doc-text" />}

      <div className="report__details">
        <h2 className={`report__category ${categoryClassName}`}>{props.category}</h2>
        <h1 className="report__title">{props.title}</h1>
        <p className="report__description">{props.description}</p>
      </div>
      <div className="report__metadata">
        <div className="report__modified">
          <div className="report__modified-label">
            <i className="icon-clock" /> Last modified
          </div>
          <div className="report__modified-date">
            {longDateString(new Date(modified))} - {lastModifiedBy}
          </div>
        </div>
      </div>
      <div className="report__actions">
        <a className="report__link" onClick={props.reportClick}>
          Preview Report
        </a>
      </div>
      <Favorite isFavorite={props.isFavorite} id={props.id} />
    </article>
  );
}
